import { hasOwnPath } from "../../arrays/api"

export const headerTokenKey = "TOKEN"

export function setToken( token,localTokenKey = 'AUTH' ) {
    localStorage.setItem( localTokenKey,token )
    return getToken() ? true : false
}
export function getToken( localTokenKey = 'AUTH' ) {
    return localStorage.getItem( localTokenKey )
}
export function delToken( localTokenKey = 'AUTH' ) {
    localStorage.removeItem( localTokenKey )
    return getToken() ? false : true
}

export function decodeToken ( token ) {
        if (typeof token !== 'string')
            return false

        const parts = token.split('.')
        if (parts.length !== 3)
            return false

        let base64 = parts[1]
            .replace(/-/g, '+')
            .replace(/_/g, '/')

        const binary = atob(base64)
        const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))

        const json = new TextDecoder('utf-8').decode(bytes)

        return JSON.parse(json)
}
export function usernameFromToken() {
    const token = getToken()
    if( !token ) return 'user.name'
    const payload = decodeToken(token)
    return (hasOwnPath(payload,'data.username') && payload.data.username) ? payload.data.username : 'user.name'
}
export function displaynameFromToken() {
    //const username = usernameFromToken()
    //return username.replace('.',' ')
    const token = getToken()
    if( !token ) return 'User name'
    const payload = decodeToken(token)
    return (hasOwnPath(payload,'data.display_name') && payload.data.display_name) ? payload.data.display_name : 'User name'
}
export function idFromToken() {
    const token = getToken()
    if( !token ) return 'id'
    const payload = decodeToken(token)
    return (hasOwnPath(payload,'data.ID') && payload.data.ID) ? payload.data.ID : 'id'
}
export function groupsFromToken() {
    const token = getToken()
    if( !token ) return []
    const payload = decodeToken(token)
    return (hasOwnPath(payload,'data.groups') && payload.data.groups) ? payload.data.groups : []
}
export function expiresatFromToken() {
    const token = getToken()
    if( !token ) return []
    const payload = decodeToken(token)
    return payload.hasOwnProperty('exp') ? payload.exp : 0
}